var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Navbar',{attrs:{"json":_vm.navigation,"corpId":_vm.corpId}}),_vm._v(" "),(!_vm.user)?_c('Login'):_vm._e(),_vm._v(" "),(_vm.user)?_c('Setup',{attrs:{"corpId":_vm.corpId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }